import "./ModalActionBtn.scss"

export enum ModalBtnType {
  light,
  dark
}

interface ModalBtnProps {
  type: ModalBtnType,
  callToAction: any | Function,
  text: string
}

const ModalActionBtn = (props: ModalBtnProps) => {
  return (
    <div className={props.type === ModalBtnType.dark ? "modalActionBtn dark" : "modalActionBtn light"} onClick={props.callToAction}>{props.text}</div>
  )
}

export default ModalActionBtn